import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import { newsList } from "@/mocks/news";

export default function SiteIntro() {
  const stats = [
    { label: "影视作品", value: `${movies.length}` },
    { label: "资讯文章", value: `${newsList.length}` },
    { label: "题材分类", value: "10+" },
    { label: "持续更新", value: "每日" },
  ];

  return (
    <section className="w-full bg-background-100 px-4 md:px-8 py-12 md:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <span className="inline-block px-3 py-1 rounded-md bg-secondary-100 text-secondary-900 text-xs mb-4">
            关于本站
          </span>
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            国产久久久 · 国产影片资源与影视资讯平台
          </h1>
          <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
            国产久久久专注于国产影视作品的整理与展示，涵盖电影、电视剧两大主体分类，并结合影视行业资讯、专题报道与影人访谈，为关注国产影视的观众提供清晰、便捷的内容浏览体验。
          </p>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            我们坚持内容为先，通过分类筛选、热度排行与编辑精选，帮助您在丰富的作品中快速找到想了解的内容。
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              了解我们
            </Link>
            <Link
              to="/contact"
              className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm whitespace-nowrap cursor-pointer hover:border-primary-400 hover:text-primary-600 transition-colors"
            >
              联系反馈
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6"
            >
              <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600">
                {stat.value}
              </p>
              <p className="mt-1.5 text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}